import React, { Component } from 'react';
import Login from '../user/login/Login';
import Signup from '../user/signup/Signup';
import OAuth2RedirectHandler from '../user/oauth2/OAuth2RedirectHandler';
import NotFound from '../common/NotFound';
import LoadingIndicator from '../common/LoadingIndicator';
import { getCurrentUser } from '../util/APIUtils';
import Layout from '../common/layout';
import { Redirect, Route, Switch } from 'react-router';
import { allow2Oauth, allowActive, allowRegister } from '../constants/config';
import Active from '../user/active/Active';
import ForgotPassword from '../user/forgotPassword';
import ChangePassword from '../user/change-password/ChangePassword';
import AcceptChangeEmail from '../user/resetEmail/AcceptChangeEmail';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      currentUser: null,
      loading: true,
    };

    this.loadCurrentlyLoggedInUser = this.loadCurrentlyLoggedInUser.bind(this);
  }

  loadCurrentlyLoggedInUser() {
    getCurrentUser()
      .then((rs) =>
        rs.json().then((response) => {
          this.setState({
            currentUser: response,
            authenticated: true,
            loading: false,
          });
        }),
      )
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  }

  componentDidMount() {
    this.loadCurrentlyLoggedInUser();
  }

  render() {
    if (this.state.loading) {
      return <LoadingIndicator />;
    }

    return (
      <Layout>
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/account/reset/finish" component={ChangePassword} />
          <Route path="/change-email/finish" component={AcceptChangeEmail} />
          {allowRegister && <Route path="/signup" component={Signup} />}
          {allow2Oauth && (
            <Route path="/oauth2/redirect" component={OAuth2RedirectHandler} />
          )}
          {allowActive && <Route path="/activate" component={Active} />}
          <Route component={NotFound} />
        </Switch>
      </Layout>
    );
  }
}

export default App;
